import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import socketService from '../services/socketService';
import { useToast } from '../contexts/ToastContext';

interface ChatAccessGrantedPayload {
  bookRequestId: string;
  bookTitle: string;
  otherUserName: string;
}

export const useChatAccessAnnouncement = () => {
  const { user } = useAuth();
  const { showSuccess } = useToast();

  useEffect(() => {
    if (!user) return;

    // Écouter l'événement chat_access_granted
    const handleChatAccessGranted = (payload: ChatAccessGrantedPayload) => {
      const { bookRequestId, bookTitle, otherUserName } = payload;
      
      // Vérifier si on a déjà affiché cette notification pour cette demande
      const storageKey = `chat_access_shown_${bookRequestId}`;
      const hasShown = localStorage.getItem(storageKey);
      
      if (hasShown) {
        console.log('Chat access notification already shown for this request');
        return;
      }
      
      // Marquer comme affiché
      localStorage.setItem(storageKey, 'true');
      
      // Afficher la notification
      showSuccess(
        'Messagerie disponible ! 💬',
        `Vous pouvez maintenant échanger avec ${otherUserName} pour organiser l'échange du livre "${bookTitle}".`
      );
    };

    // S'abonner à l'événement
    socketService.onChatAccessGranted(handleChatAccessGranted);

    // Cleanup
    return () => {
      socketService.removeChatAccessGrantedListener();
    };
  }, [user, showSuccess]);
};
